import { render, staticRenderFns } from "./IncrementalNavLink.vue?vue&type=template&id=9f79676e&"
import script from "./IncrementalNavLink.vue?vue&type=script&lang=js&"
export * from "./IncrementalNavLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports